import React from 'react';
import { StyleSheet, Text, View, Modal } from 'react-native';
import GenericButton from '../components/molecules/buttons/GenericButton';
import { useAuthStateContext, useToastContext } from '../contexts';

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  modalContent: {
    backgroundColor: 'white',
    padding: 20,
    borderRadius: 10,
    width: 300,
    alignItems: 'center'
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    width: '50%'
  }
});

interface LogoutModal {
  modalVisible: boolean;
  setModalVisible: (modalVisible: boolean) => void;
}

/**
 * LogoutModal component
 *
 * @param {*} { modalVisible, setModalVisible }
 * @return {*}
 */
const LogoutModal: React.FC<LogoutModal> = ({ modalVisible, setModalVisible }) => {
  const authStateContext = useAuthStateContext();
  const toast = useToastContext();
  const confirmLogout = async () => {
    authStateContext.auth.signoutRedirect();
    toast.showToast('Logged out successfully', 3000, true);
    setModalVisible(false);
  };

  return (
    <Modal visible={modalVisible} transparent={true} onRequestClose={() => setModalVisible(false)}>
      <View style={styles.modalContainer}>
        <View style={styles.modalContent}>
          <Text>Are you sure you want to log out?</Text>
          <View style={styles.buttonContainer}>
            <GenericButton title="YES" onPress={confirmLogout} isPrimary />
            <GenericButton
              title="NO"
              onPress={() => {
                setModalVisible(false);
              }}
              isPrimary={false}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default LogoutModal;
